import { render, staticRenderFns } from "./CourseBreadcrumbs.vue?vue&type=template&id=513d1571&scoped=true&"
import script from "./CourseBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./CourseBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./CourseBreadcrumbs.vue?vue&type=style&index=0&id=513d1571&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513d1571",
  null
  
)

export default component.exports